const routes = [{
  path: '/',
  name: 'login',
  component: resolve => require(['../views/login/index'], resolve)
}, {
  path: '/forget',
  name: 'forget',
  component: resolve => require(['../views/forget/index'], resolve)
}, {
  path: '/register',
  name: 'register',
  component: resolve => require(['../views/register/index'], resolve)
}]

export default routes


// WEBPACK FOOTER //
// ./src/router/router.js